import { render } from "./taskList.vue?vue&type=template&id=d8c36a02&scoped=true"
import script from "./taskList.vue?vue&type=script&lang=js"
export * from "./taskList.vue?vue&type=script&lang=js"

import "./taskList.vue?vue&type=style&index=0&id=d8c36a02&lang=scss&scoped=true"

import exportComponent from "E:\\project_copy_from_e\\项目\\后台\\cost_admin\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d8c36a02"]])

export default __exports__